// src/services/api.ts (ATUALIZADO - versão completa)
import axios from 'axios';

const getApiBaseUrl = () => {
  // Em produção, usa caminho relativo (mesmo domínio com HTTPS)
  if (process.env.NODE_ENV === 'production') {
    return '/api'; // Usa proxy do Apache via HTTPS
  }
  
  // Em desenvolvimento
  return process.env.REACT_APP_API_URL || 'http://localhost:3001';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Importante para cookies/sessões HTTPS
  timeout: 30000,
});

// Interceptor para adicionar token admin
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Serviços de Servidor
export const searchEmployeeByCPF = async (cpf: string) => {
  const response = await api.get(`/servidores/publico/cpf/${cpf}`);
  return response.data;
};


export const gerarContrato = async (servidorId: number, dados: any) => {
  const response = await api.post(`/documentos/gerar-contrato/${servidorId}`, dados);
  return response.data;
};

export const validarCodigo = async (token: string, codigo: string) => {
  const response = await api.post('/auth/validar-codigo', { token, codigo });
  return response.data;
};

export const buscarDocumentosServidor = async (servidorId: number) => {
  const response = await api.get(`/documentos/servidor/${servidorId}`);
  return response.data;
};

export const solicitarValidacaoEmail = async (cpf: string, email: string, telefone?: string) => {
  const response = await api.post('/auth/solicitar-validacao', { cpf, email, telefone });
  return response.data;
};

export const solicitarCodigoAcessoDocumentos = async (cpf: string, telefone?: string) => {
  const response = await api.post('/documentos/solicitar-acesso', { cpf, telefone });
  return response.data;
};

export const buscarPdfParaAssinatura = async (documentoId: number, servidorId: number) => {
  const response = await api.get(`/documentos/${documentoId}/pdf/${servidorId}`);
  return response.data;
};

export const assinarDocumentoComImagem = async (
  servidorId: number,
  documentoId: number,
  assinaturaBase64: string,
  cpf: string
) => {
  const response = await api.post(`/documentos/assinar-com-imagem/${servidorId}`, {
    documentoId,
    assinatura: assinaturaBase64,
    cpf
  });
  return response.data;
};

export const downloadPdfAssinado = async (servidorId: number, documentoId: number) => {
  const response = await api.get(`/documentos/download-assinado/${servidorId}/${documentoId}`, {
    responseType: 'blob' // Importante para download de arquivos
  });
  return response.data;
};

// FUNÇÃO PARA FAZER DOWNLOAD DO PDF ASSINADO
export const baixarPdfAssinado = (servidorId: number, documentoId: number, nomeArquivo: string) => {
  const link = document.createElement('a');
  link.href = `${API_BASE_URL}/documentos/download-assinado/${servidorId}/${documentoId}`;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// NOVOS SERVIÇOS
export const gerarLinkAcesso = async (cpf: string, email: string, documentoId?: number) => {
  const response = await api.post('/documentos/gerar-link', { cpf, email, documentoId });
  return response.data;
};


export const visualizarDocumento = async (token: string) => {
  const response = await api.get(`/documentos/validar-acesso/${token}`);
  return response.data;
};

// FUNÇÃO 2: Assinar documento com token (para VisualizacaoPage.tsx)
export const assinarDocumentoToken = async (token: string, documentoId: number, dados: any) => {
  const response = await api.post(`/documentos/assinar/${token}/${documentoId}`, dados);
  return response.data;
};

export const acompanharDocumento = async (codigo: string) => {
  const response = await api.get(`/documentos/acompanhar/${codigo}`);
  return response.data;
};

// Admin
export const listarTodosDocumentosAdmin = async (filtro?: string) => {
  const response = await api.get('/documentos/admin/todos', { params: { filtro } });
  return response.data;
};

export const uploadDocumentoAdmin = async (servidorId: number, file: File, tipo: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('tipo', tipo);
  
  const response = await api.post(`/documentos/admin/upload/${servidorId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const listarArquivosDisponiveis = async (diretorio?: string) => {
  const response = await api.get('/documentos/listar-arquivos', { 
    params: { diretorio } 
  });
  return response.data;
};

export const importarDocumentosEmMassa = async (dados: {
  diretorio?: string;
  tipo?: string;
  processarAutomaticamente?: boolean;
}) => {
  const response = await api.post('/documentos/importar-em-massa', dados);
  return response.data;
};

export const verificarAssociacoes = async (documentoId?: number) => {
  const response = await api.get('/documentos/verificar-associacoes', { 
    params: { documentoId } 
  });
  return response.data;
};

export const corrigirAssociacao = async (documentoId: number, servidorId: number) => {
  const response = await api.post(`/documentos/corrigir-associacao/${documentoId}/${servidorId}`);
  return response.data;
};

// NOVO: Validar código de acesso para documentos
export const validarCodigoAcessoDocumentos = async (codigo: string) => {
  const response = await api.post('/documentos/validar-acesso-codigo', { codigo });
  return response.data;
};

// NOVO: Buscar documentos por token de sessão
export const buscarDocumentosPorSessao = async (sessionToken: string) => {
  const response = await api.get(`/documentos/sessao/${sessionToken}`);
  return response.data;
};

export default api;